'use strict';

/**
 * Created by kinsellad on 30/01/2017.
 */
define(['app', '$window'], function (app, $window) {

  var productBlock = function productBlock() {
    var self = this;
    var DATA_OPTION_ID = 'data-option-id';
    var DATA_LINKED_SWATCH = 'data-linked-swatch';
    var DATA_ALT_SRC = 'data-alt-src';
    var DATA_TRACK_HOVER = 'data-component-tracked-hovered';
    var DATA_TRACK_FOCUS = 'data-component-tracked-focused';
    var DATA_CONTEXT = 'data-context';

    self.app = app; // locally reference app object

    var _config = {
      buttonSelector: '[data-js-element=button]',
      buttonClickEvent: 'productBlock-buttonClick',
      quickViewIconSelector: '[data-js-element=quickViewIcon]',
      quickViewIconClickEvent: 'productBlock-quickViewClick',
      productDataSelector: '[data-js-element=productBlock_data]',
      colorSwatch: '.productBlock_colorSwatches_swatch',
      image: '.productBlock_image',
      imageLink: '.productBlock_link',
      rolloverWrapper: '.productBlock_imageLinkWrapper',
      productBlockRatingSelector: '.productBlock_rating',
      productBlockPriceSelector: '.productBlock_priceBlock'
    };

    var _init = function _init(element) {
      self.element = element;
      self.button = self.element.querySelector(self.config.buttonSelector);
      self.quickViewIcon = self.element.querySelector(self.config.quickViewIconSelector);
      self.productData = self.element.querySelector(self.config.productDataSelector);
      self.colorSwatches = self.element.querySelectorAll(self.config.colorSwatch);
      self.image = self.element.querySelector(self.config.image);
      self.imageLink = self.element.querySelector(self.config.imageLink);
      self.originalSrc = self.image.src;
      self.rolloverWrapper = self.element.querySelector(self.config.rolloverWrapper);
      self.productBlockRatingButton = self.element.querySelector(self.config.productBlockRatingSelector);
      self.productBlockPriceButton = self.element.querySelector(self.config.productBlockPriceSelector);
      self.bind();
      return self;
    };

    var _bind = function _bind() {

      if (self.button) {
        self.button.addEventListener('click', self.buttonClicked);
      }
      if (self.quickViewIcon) {
        self.quickViewIcon.addEventListener('click', self.quickViewIconClicked);
      }

      if (self.productBlockRatingButton && self.productBlockRatingButton.getAttribute('data-is-link') === 'true') {
        self.productBlockRatingButton.addEventListener('click', self.goToProductPage);
      }

      if (self.productBlockPriceButton && self.productBlockPriceButton.getAttribute('data-is-link') === 'true') {
        self.productBlockPriceButton.addEventListener('click', self.goToProductPage);
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = self.colorSwatches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var colorSwatch = _step.value;

          colorSwatch.addEventListener('click', self.colorSwatchClicked.bind(null, colorSwatch));
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if ($window.innerWidth > 900) {
        if (self.image.hasAttribute(DATA_ALT_SRC) && self.image.getAttribute(DATA_ALT_SRC) !== '') {
          self.rolloverWrapper.addEventListener('mouseover', self.imageRolloverIn);
          self.imageLink.addEventListener('focusin', self.imageRolloverIn);
          self.rolloverWrapper.addEventListener('mouseleave', self.imageRolloverOut);
          self.imageLink.addEventListener('focusout', self.imageRolloverOut);

          if (!self.rolloverWrapper.hasAttribute(DATA_TRACK_HOVER)) {
            self.rolloverWrapper.setAttribute(DATA_TRACK_HOVER, "");
            self.rolloverWrapper.setAttribute(DATA_CONTEXT, "imageRollover-hover");
          }

          if (!self.imageLink.hasAttribute(DATA_TRACK_FOCUS)) {
            self.imageLink.setAttribute(DATA_TRACK_FOCUS, "");
            self.imageLink.setAttribute(DATA_CONTEXT, "imageRollover-focus");
          }
        }
      }
    };

    var _buttonClicked = function _buttonClicked() {
      self.app.publish(self.config.buttonClickEvent);
    };

    var _quickViewIconClicked = function _quickViewIconClicked(event) {
      //This currently triggers the old quickview component
      event.preventDefault();
      self.app.publish(self.config.quickViewIconClickEvent);
    };

    var _colorSwatchClicked = function _colorSwatchClicked(colorSwatch) {
      if (colorSwatch.hasAttribute(DATA_LINKED_SWATCH)) {
        var clickedProductId = colorSwatch.getAttribute(DATA_OPTION_ID);
        app.publish('tracking/record', 'Linked SKU Engagement', 'Clicked away from ' + self.masterProductId, 'Clicked on ' + clickedProductId);
      }
    };

    var _imageRolloverIn = function _imageRolloverIn() {
      self.image.src = self.image.getAttribute(DATA_ALT_SRC);
    };

    var _imageRolloverOut = function _imageRolloverOut() {
      self.image.src = self.originalSrc;
    };

    var _goToProductPage = function _goToProductPage() {
      window.location.href = self.imageLink.href;
    };

    self.config = _config;
    self.init = _init;
    self.bind = _bind;
    self.imageRolloverIn = _imageRolloverIn;
    self.imageRolloverOut = _imageRolloverOut;
    self.colorSwatchClicked = _colorSwatchClicked;
    self.buttonClicked = _buttonClicked;
    self.quickViewIconClicked = _quickViewIconClicked;
    self.goToProductPage = _goToProductPage;
  };

  return productBlock;
});
//# sourceMappingURL=productBlock.js.map
